'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../hooks';
import { BrandContentLegacy } from './BrandContent.legacy';
import { BrandContentV2 } from './BrandContent.v2';
type BrandContentProps = {
  initializeWebcollage: () => void;
};
export function BrandContentScript(t0) {
  const $ = _c(3);
  const {
    initializeWebcollage
  } = t0;
  const isOneTrust = useDecisions("onetrust");
  const ScriptComponent = isOneTrust ? BrandContentV2 : BrandContentLegacy;
  let t1;
  if ($[0] !== ScriptComponent || $[1] !== initializeWebcollage) {
    t1 = <ScriptComponent initializeWebcollage={initializeWebcollage} />;
    $[0] = ScriptComponent;
    $[1] = initializeWebcollage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}